import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import {
  ArrowCircleRightNoshadowIcon,
  ArrowCircleDownNoshadowIcon,
} from "wm-graphics";
import { Slide } from "../../../animations/Slide/Slide";

import "./AccordionItem.scss";

export class AccordionItem extends React.Component {
  static defaultProps = {
    defaultIsOpen: false,
  };

  static propTypes = {
    /** Additional class names for the component */
    className: PropTypes.string,
    /** Callback function for when tab is clicked */
    id: PropTypes.any,
    /** Label associated with component */
    label: PropTypes.string,
    /** JSX objects to be rendered */
    children: PropTypes.node,
    /** The default state for whether it is open or not */
    defaultIsOpen: PropTypes.bool,
    /** onClick call back can be used of higher level component state management */
    onClick: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      isOpen: props.defaultIsOpen,
    };
  }

  componentDidUpdate(prevProps) {
    const { defaultIsOpen } = this.props;

    if (prevProps.defaultIsOpen !== defaultIsOpen) {
      this.setIsOpen(defaultIsOpen);
    }
  }

  setIsOpen = (newIsOpen) => {
    this.setState({
      isOpen: newIsOpen,
    });
  };

  onClick = () => {
    const { onClick } = this.props;
    const { isOpen } = this.state;
    const newIsOpen = !isOpen;

    this.setIsOpen(newIsOpen);

    if (onClick) {
      onClick(newIsOpen);
    }
  };

  onKeyDownHandler = (event) => {
    if (event.key === "Enter") {
      this.onClick();
    }
  };

  render() {
    const { children, className, id, label } = this.props;
    const { isOpen } = this.state;

    const accordionItemClass = classNames(className, "accordionItem", {
      isOpen,
      className,
    });

    return (
      <div className={accordionItemClass} id={id}>
        <div
          className="accordionItem__tab"
          data-testid="accordion-item"
          onClick={this.onClick}
          onKeyDown={this.onKeyDownHandler}
          role="button"
          tabIndex={0}
        >
          <div className="accordionItem__label">{label}</div>
          <div className="accordionItem__icon">
            {isOpen ? (
              <ArrowCircleDownNoshadowIcon width={17} height={17} />
            ) : (
              <ArrowCircleRightNoshadowIcon width={17} height={17} />
            )}
          </div>
        </div>
        <Slide isVisible={isOpen}>{children}</Slide>
      </div>
    );
  }
}

export default AccordionItem;
